var map = {
	"./add_page.svg": "6b73",
	"./arrow_back_white.svg": "071d",
	"./attention_icon.svg": "d2cc",
	"./book_icon.svg": "d8d5",
	"./bookshelf_icon.svg": "390d",
	"./circle.svg": "b289",
	"./color_icon.svg": "7995",
	"./firstCustom.svg": "f649",
	"./flag_of_denmark.svg": "92eb",
	"./flag_of_russia.svg": "134b",
	"./flag_of_the_united_states.svg": "7021",
	"./fourthCustom.svg": "dda8",
	"./front_page_icon.svg": "0b1a",
	"./hint_icon.svg": "a246",
	"./next_step.svg": "22e1",
	"./polygon.svg": "baf3",
	"./right_answer_icon.svg": "2af9",
	"./secondCustom.svg": "6a44",
	"./speak_text_icon.svg": "797d",
	"./square.svg": "d8a7",
	"./thirdCustom.svg": "8ff2",
	"./triangle.svg": "a8fe",
	"./wrong_icon.svg": "d411"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";